import { useState } from "react";
import { InputRadioOp2Props } from "./InputRadioOp2.type";

const INPUT_COLOR_ERROR = "red";
const INPUT_COLOR = "#D0D0D0";

export default function InputRadioOp2({
  fieldName,
  label,
  register,
  required,
  error,
  onChange,
  option1,
  option2,
  labelForComment,
  getValues,
  setValue,
}: InputRadioOp2Props) {
  const [showTextArea, setShowTextArea] = useState(
    !!getValues?.(`${fieldName}_comment`),
  );

  return (
    <>
      <div className="w-full flex  flex-col md:flex-row align-middle">
        <label className="w-full">{label}</label>
        <div className="w-full">
          <div className="mr-3 flex  md:justify-end">
            <label className="mx-3">
              <input
                type="radio"
                className="mx-1 sm:mx-3 text-red-500"
                {...register(fieldName, {
                  required,
                })}
                checked={showTextArea}
                value={option1}
                onClick={() => setShowTextArea(true)}
              />
              {option1 ? option1 : undefined}
            </label>
            <label className="mx-3">
              <input
                type="radio"
                className="mx-1 sm:mx-3 text-red-500"
                {...register(fieldName, {
                  required,
                })}
                value={option2}
                onClick={() => {
                  setValue(`${fieldName}_comment`, "");
                  setShowTextArea(false);
                }}
              />
              {option2 ? option2 : undefined}
            </label>
          </div>
          {showTextArea ? (
            <div className="m-1 p-2 w-full">
              <textarea
                className="rounded w-full"
                {...register(`${fieldName}_comment`, {
                  required,
                  onChange: (e) => {
                    onChange && onChange(e);
                  },
                })}
                style={{
                  borderColor: `${error ? INPUT_COLOR_ERROR : INPUT_COLOR}`,
                }}
                rows={3}
                placeholder={labelForComment}
              >
                </textarea></div>
          ) : undefined}
        </div>
        {/* ERRORS MESSAGE */}
        {error?.message && (
          <span style={{ color: INPUT_COLOR_ERROR }}>{error?.message}</span>
        )}
        {error?.type === "required" && (
          <span style={{ color: INPUT_COLOR_ERROR }}>Campo Obligatorio*</span>
        )}
      </div>
    </>
  );
}
